import React from "react";

const statusStyles = {
  pending: {
    color: "#3047EC",
    icon: "/search-normal-blue.svg",
  },
  approved: {
    color: "#46DA55",
    icon: "/green-tick.svg",
  },
  rejected: {
    color: "#FF5050",
    icon: "/reject-red.svg",
  },
};

const StatusButton = ({ status = "", count = 0, openSection, disabled }) => {
  const normalizedStatus = status?.toLowerCase() || "pending";
  const { color, icon } =
    statusStyles[normalizedStatus] || statusStyles.pending;

  return (
    <button
      onClick={openSection}
      disabled={disabled}
      className={`flex text-xs bg-opacity-20 font-medium items-center border py-1 lg:px-2 px-1 rounded transition duration-200 hover:opacity-80`}
      style={{
        color,
        borderColor: color,
        backgroundColor: `${color}20`,
      }}
    >
      <img
        src={icon}
        alt={`${status} icon`}
        className="h-2 w-2 md:h-3 md:w-3 md:mr-1"
      />
      <span className="hidden font-semibold lg:inline">
        {status ? status=="in_review" ?"Pending":status.charAt(0).toUpperCase() + status.slice(1) : "Unknown"}
      </span>
      <span className="hidden font-semibold lg:inline px-2">({count})</span>
    </button>
  );
};

export default StatusButton;
